import {
  SendPurchaseOrderFormData,
  PostPurchaseOrderEmailRequestBody,
  PostPurchaseOrderPDFRequestBody
} from "src/types";

export class SendPurchaseOrderMapper {
  public static initSendPurchaseOrderFormData(): SendPurchaseOrderFormData {
    return {
      purchaseOrderId: "",
      vendorName: "",
      additionalInfo: ""
    };
  }

  public static sendPurchaseOrderRequestBodyFromFormData(
    sendPurchaseOrderFormData: SendPurchaseOrderFormData
  ): PostPurchaseOrderEmailRequestBody {
    return {
      vendorName: sendPurchaseOrderFormData.vendorName,
      additionalInfo: sendPurchaseOrderFormData.additionalInfo || undefined
    };
  }

  public static createPurchaseOrderPDFRequestBodyFromFormData(
    sendPurchaseOrderFormData: SendPurchaseOrderFormData
  ): PostPurchaseOrderPDFRequestBody {
    return {
      vendorName: sendPurchaseOrderFormData.vendorName
    };
  }
}
